import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BlogPost, CmsUiBlogSliderContent } from '@lobos/library';
import { TranslocoService } from '@ngneat/transloco';
import SwiperCore, { Navigation, Pagination, SwiperOptions } from 'swiper';

SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-blog-slider',
  templateUrl: './blog-slider.component.html',
  styleUrls: ['./blog-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogSliderComponent implements OnInit {
  @Input() data!: CmsUiBlogSliderContent;

  swiperConfig: SwiperOptions | undefined;

  constructor(private translocoService: TranslocoService) {}

  public ngOnInit(): void {
    this.swiperConfig = {
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: `.swiper-pagination-${this.data.id}`,
        type: 'bullets',
        dynamicBullets: false,
        clickable: true,
        bulletElement: 'button',
      },
      navigation: {
        nextEl: `.swiper-arrow--next-${this.data.id}`,
        prevEl: `.swiper-arrow--prev-${this.data.id}`,
      },
      breakpoints: {
        769: {
          slidesPerView: 2,
        },
        1025: {
          slidesPerView: 3,
        },
      },
    };
  }

  getBlogPostPath(blogPost: BlogPost): string {
    return `/${this.translocoService.getActiveLang()}${blogPost.slug}`;
  }
}
